import Breadcrumb from "../../components/common/Breadcrumb";
import stylesgfi from "./NationalSchoolGames.module.css";
import { Button, Container, Row, Col } from "react-bootstrap";

function SubJuniorMensHockey2026() {
  return (
    <>
      <Breadcrumb
        pageName={SubJuniorMensHockey2026}
        pageTitle={"Sub Junior Mens Hockey 2026"}
        img_url={"/img/sub-jun-hock-16-banner.png"}
        mobile_banner="./img/sub-jun-hock-16-mobile.jpeg"
      />
      {/* <div>
        <h1 className={`${stylesgfi.title}`}>
          16वीं हॉकी इंडिया सब जूनियर पुरुष राष्ट्रीय चैम्पियनशिप 2026
        </h1>
      </div>

      <Container className="button-container mt-5">
        <div className="mt-5" style={{ marginTop: "40px" }}>
          <Row className="justify-content-center">
            {[
              { label: "Match Schedule", href: "/sub-junior-mens-hockey-2026/match-schedule" },
              { label: "Results", href: "/sub-junior-mens-hockey-2026/results" },
              { label: "Points Table", href: "/sub-junior-mens-hockey-2026/points-table" },
              { label: "Teams", href: "/sub-junior-mens-hockey-2026/teams" },
            ].map((btn) => (
              <Col key={btn.label} xs={12} md={3} className="text-center" style={{ marginTop: "20px" }}>
                <Button
                  className="animated-button"
                  href={btn.href}
                  style={{
                    backgroundColor: "#1a237e",
                    borderColor: "#1a237e",
                    color: "#ffffff",
                    padding: "10px 20px",
                    fontWeight: "600",
                    minWidth: "140px",
                  }}
                >
                  {btn.label}
                </Button>
              </Col>
            ))}
          </Row>
        </div>
      </Container> */}

      <div
        style={{
          backgroundImage: "url('/img/bghockyimg.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "350px", // increased height
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          paddingTop: "70px", // ✅ top gap for mobile
          paddingBottom: "40px", // ✅ bottom spacing
        }}
      >
        {/* Return button — top left */}
        <div style={{ position: "absolute", top: "16px", left: "16px" }}>
          <Button
            href="/"
            style={{
              backgroundColor: "#1a237e",
              borderColor: "#1a237e",
              color: "#fff",
              fontSize: "13px",
              padding: "6px 16px",
            }}
          >
            ← Return
          </Button>
        </div>

        {/* Content */}
        <div
          style={{
            width: "100%",
            textAlign: "center",
            padding: "0 15px",
          }}
        >
          {/* Title */}
          <h1
            className={stylesgfi.title}
            style={{
              marginTop: "20px",
              marginBottom: "25px",
              color: "#1a237e",
              fontSize: "28px",
              fontWeight: "700",
            }}
          >
            16वीं हॉकी इंडिया सब जूनियर पुरुष राष्ट्रीय चैम्पियनशिप 2026
          </h1>

          {/* Buttons */}
          <Container className="button-container mt-4">
            <Row className="justify-content-center">
              {[
                {
                  label: "Match Schedule",
                  href: "/sub-junior-mens-hockey-2026/match-schedule-sub-junior-mens-hockey-2026",
                },
                {
                  label: "Results",
                  href: "/sub-junior-mens-hockey-2026/results-sub-junior-mens-hockey-2026",
                },
                {
                  label: "Points Table",
                  href: "/sub-junior-mens-hockey-2026/points-table-sub-junior-mens-hockey-2026",
                },
                {
                  label: "Teams",
                  href: "/sub-junior-mens-hockey-2026/teams-sub-junior-mens-hockey-2026",
                },
                {
                  label: "Knockout Stage",
                  href: "/sub-junior-mens-hockey-2026/Knockout-sub-junior-mens-hockey-2026",
                },
              ].map((btn) => (
                <Col
                  key={btn.label}
                  xs={12}
                  md={3}
                  className="text-center"
                  style={{ marginTop: "15px" }} // ✅ spacing between buttons
                >
                  <Button
                    href={btn.href}
                    style={{
                      backgroundColor: "#1a237e",
                      borderColor: "#1a237e",
                      color: "#fff",
                      padding: "12px 20px",
                      fontWeight: "600",
                      minWidth: "180px",
                      borderRadius: "8px",
                    }}
                  >
                    {btn.label}
                  </Button>
                </Col>
              ))}
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default SubJuniorMensHockey2026;
